
<template>
    <div>
        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
                <div class="card-icon">
                    <md-icon>group</md-icon>
                </div>
            </md-card-header>

            <md-card-content>
                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <div class="md-layout md-alignment-top-left single_step_wizard">

                                <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>


                                <div class="md-layout-item md-medium-size-100 md-xlarge-size-50">
                                    <h3>Contact Details</h3>
                                    <p class="margin_bottom">Contact's essential information</p>


                                      <div class="md-layout md-gutter margin_bottom">
                                        <label class="md-layout-item md-size-25 md-form-label top_pad_min">
                                            Organisation
                                        </label>
                                        <div class="md-layout-item md-size-40">
                                            <md-radio v-for="option in contactTypeOptions" v-model="contact.contactType" :key="option.id" :value="option.id" :disabled="isEditMode">{{option.name}}</md-radio>
                                             <FadeTransition :duration="400" mode="out-in" v-if="isFmContact" tag="div" class="val_with_extras">
                                                <md-field class="margin_top_slight offset_val">
                                                    <label for="facilitiesManagerId">Choose Facilities Manager</label>
                                                    <md-select v-model="contact.facilitiesManagerId" name="facilitiesManagerId" id="facilitiesManagerId" :disabled="isEditMode">
                                                        <md-option v-for="fm in fms" :key="fm.id" :value="fm.id">{{fm.name}}</md-option>
                                                    </md-select>
                                                </md-field>
                                            </FadeTransition>
                                                 <FadeTransition :duration="400" mode="out-in" v-else-if="isPortfolioContact" tag="div" class="val_with_extras">
                                                <md-field class="margin_top_slight offset_val">
                                                    <label for="facilitiesManagerId">Choose Portfolio</label>
                                                    <md-select v-model="contact.portfolioId" name="portfolioId" id="portfolioId" :disabled="isEditMode">
                                                        <md-option v-for="p in portfolios" :key="p.id" :value="p.id">{{p.name}}</md-option>
                                                    </md-select>
                                                </md-field>
                                            </FadeTransition>
                                        </div>
                                    </div>

                                    <contact-inner-details :contact="contact" v-disable-all="detailsDisabled" >
                                    </contact-inner-details>
            
                                </div>
                            </div>
                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>

                        <div class="stepper-buttons-wrap md-layout md-alignment-space-between">
                            <div class="md-layout-item md-alignment-top-right md-layout">
                                <md-button class="md-primary" @click="validatePageSaveOrAlert">Save</md-button>
                            </div>
                        </div>

                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { FadeTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import { extend } from "vee-validate";
    import { required, email, min } from "vee-validate/dist/rules";
    extend("email", email);
    extend("required", required);
    extend("min", min);

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import Api from '@/ts/UvApiService';
    import { ContactTypes } from '@/ts/ContactComponents';
    import ContactInnerDetails from '@/components/Contact/InnerDetails.vue';

    export default {
        components: {
            ContactInnerDetails
            , FadeTransition
            , Loader
        },
        data() {
            return {
                loading: true,
                notification: null,
                contact: {},
                contactTypeOptions:[
                      { id: 1, name: "In-House" }
                    , { id: 2, name: "Facilities Management Co..." }
                    , { id: 3, name: "Portfolio..." }
                ],
                fms: [],
                portfolios: [],
            }
        },
        methods: {
            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this Contact`;
                this.$notify({
                    timeout: 3500,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            done() {
                this.$router.push(`/contacts`);

                setTimeout(() => {
                    this.$notify({
                        timeout: 8500,
                        message: `Contact <b>${this.contact.name}</b> was saved`,
                        icon: "thumb_up",
                        horizontalAlign: "center",
                        verticalAlign: "top",
                        type: NotyTypes[NotyTypes.success],
                        animate: {
                            enter: 'animated fadeInDown',
                            exit: 'animated fadeOutUp'
                        }
                    });
                }, 600);
            },
            notifyErrors(errorsArray) {
                var errorsLis = "";

                errorsArray.forEach((e) => {
                    if (e.length > 0) {
                        e.flat().forEach((ei) => {
                            errorsLis += `<li>${Help.removeFullStop(ei)}</li>`;
                        });
                    }
                });

                this.$notify({
                    timeout: 2500,
                    message: `Please <b>fix all errors</b> on the current page <b>to proceed</b><ul>${errorsLis}</ul>`,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            async validatePageSaveOrAlert() {
                this.$refs.valObserver.validate().then(async success => {

                    if (!success) {

                        setTimeout(() => { //TODO: update vee validate timeout here is to ensure errors are there and correct https://github.com/logaretm/vee-validate/issues/2248#issuecomment-578229806
                            this.notifyErrors(Object.values(this.$refs.valObserver.errors));
                        }, 100);

                        return;
                    }
                    else {
                        //hacky fixup for new //TODO:TD this is needed as this CWiz uses Organisation portfolioId facilitiesManagerId and contactType instead of the []s and the isStaff like rest of portal.
                        //align it all instead!
                        this.contact.isStaff = this.isStaffContact;
                        this.contact.facilitiesManagers = this.contactFms;
                        this.contact.portfolios = this.contactPortfolios;

                        await Api.contacts.upsertContact(this.contact);
                        this.done();
                    }
                });
            }
        },
        computed: {
            isEditMode() {
                return !Help.isNullOrUndef(this.contact) && Help.isGoodNumber(this.contact.id) && this.contact.id > 0;
            },
            pageTitle() {
                var respVal = "New Contact";
                if (this.isEditMode) {
                    respVal = "Edit Contact";
                }
                return respVal;
            },
            isStaffContact() {
                return this.contact.contactType === ContactTypes.staff;
            },
            isFmContact() {
                return this.contact.contactType === ContactTypes.facilitiesManagement;
            },
            isPortfolioContact() {
                return this.contact.contactType === ContactTypes.portfolio;
            },
            detailsDisabled() {
                return this.loading || !this.organisationIdChosen;
            },
            organisationIdChosen() {
                return (this.isStaffContact)
                    || (this.isFmContact && !Help.isNullOrUndef(this.contact) && Help.isGoodNumber(this.contact.facilitiesManagerId))
                    || (this.isPortfolioContact && !Help.isNullOrUndef(this.contact) && Help.isGoodNumber(this.contact.portfolioId));
            },
            contactFms() {               //hacky fixup for new
                if (this.organisationIdChosen && this.isFmContact) {
                        return [this.contact.facilitiesManagerId]
                }
                return [];
            },
            contactPortfolios() {               //hacky fixup for new 
                if (this.organisationIdChosen && this.isPortfolioContact) {
                        return [this.contact.portfolioId]
                }
                return [];
            }
        },
        async created() {
            this.loading = true;
            if (!Help.isNullOrUndef(this.$route.params.contactId)) {
                this.contact = await Api.contacts.getContact(this.$route.params.contactId);
                if (this.isFmContact) {
                    this.fms = [{ id: this.contact.facilitiesManagerId, name: this.contact.organisation }];
                }
                else if (this.isPortfolioContact) {
                    this.portfolios = [{ id: this.contact.portfolioId, name: this.contact.organisation }];
                }
          
            }
            else {
                this.fms = await Api.facilitiesManagers.getAllSimple();
                this.portfolios = await Api.portfolios.getAllSimple();
                this.contact = {
                    id: 0,
                    name: null,
                    email: null,
                    telephone: null,
                };
            }
            this.loading = false;
        }
    }
</script>
<style lang="scss">
</style>

<!--
     //dialogTitle() {
            //    return this.controlState === ControlStates.editing ? "Edit Contact" : "Add Contact";
            //},
            //dialogSubtitle() {
            //    if (this.controlState === ControlStates.editing)
            //        return this.isStaff ? "Edit in-house contact" : "Edit external organisation contact";
            //    else
            //        return this.isStaff ? "To in-house team" : "To external organisation";
            //},-->

